import React from "react";
import { useI18n } from "../i18n/I18nContext";
import { useContent } from "../hooks/useContent";
import { useSeo } from "../components/SEO";
import PageHero from "../components/PageHero";
import { Section } from "../components/Primitives";
import LeadForm from "../components/LeadForm";
import { BedDouble } from "lucide-react";

export default function Admission() {
  const { t, pick } = useI18n();
  useSeo(t("nav.admission"), "Admission et disponibilités à la Résidence Doux Instants : types de chambres, tarifs et processus. Planifiez une visite.");
  const { data: rooms = [] } = useContent("rooms");
  const { data: availability = [] } = useContent("availability");

  return (
    <>
      <PageHero eyebrow={t("nav.admission")} title={t("home.admissionTitle")}
        image="https://images.pexels.com/photos/7028116/pexels-photo-7028116.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" />

      <Section tone="surface" data-testid="rooms-section">
        <h2 className="font-display text-3xl sm:text-4xl">Chambres et tarifs</h2>
        <div className="mt-8 grid gap-5 sm:grid-cols-2">
          {rooms.map((r) => (
            <div key={r.id} className="overflow-hidden rounded-2xl border border-black/5 bg-white">
              <div className="aspect-[16/9] w-full bg-[#EEF1E9]">
                {r.image ? <img src={r.image} alt={pick(r.name)} className="h-full w-full object-cover" loading="lazy" />
                  : <div className="flex h-full w-full items-center justify-center text-[#9CAF88]"><BedDouble className="h-10 w-10" /></div>}
              </div>
              <div className="p-6">
                <h3 className="font-display text-xl">{pick(r.name)}</h3>
                <p className="mt-2 text-[15px] text-[#5C6370]">{pick(r.desc)}</p>
                <div className="mt-4 flex flex-wrap gap-x-6 gap-y-1 text-sm">
                  <span><strong>{t("common.price")} :</strong> {pick(r.price)}</span>
                  <span><strong>{t("common.availability")} :</strong> {pick(r.availability)}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </Section>

      <Section tone="sage" data-testid="availability-section">
        <h2 className="font-display text-3xl sm:text-4xl">Disponibilités</h2>
        <div className="mt-6 overflow-hidden rounded-2xl border border-black/5 bg-white">
          <table className="w-full text-left text-[15px]">
            <thead className="bg-[#EEF1E9] text-sm uppercase tracking-wide text-[#5C6370]">
              <tr><th className="p-4">Type</th><th className="p-4">Statut</th><th className="p-4">Note</th></tr>
            </thead>
            <tbody>
              {availability.map((a) => (
                <tr key={a.id} className="border-t border-black/5">
                  <td className="p-4 font-medium">{pick(a.room_type)}</td>
                  <td className="p-4">{pick(a.status)}</td>
                  <td className="p-4 text-[#5C6370]">{pick(a.note)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Section>

      <Section tone="base" data-testid="admission-form-section">
        <h2 className="font-display text-3xl sm:text-4xl">{t("forms.visitTitle")}</h2>
        <div className="mt-8 max-w-2xl rounded-3xl border border-black/5 bg-white p-6 sm:p-8">
          <LeadForm kind="visit" />
        </div>
      </Section>
    </>
  );
}
